import http from '@/assets/plugin/prototypes/modules/http.js'

//获取购物车列表
export function listCart(data) {
  return http.post("cart/list",data)
}

//更新购物车
export function updateCart(data) {
  return http.post("cart/update",data)
}

//创建购物车
export function addCart(data) {
  return http.post("cart/create",data)
}

//删除商品
export function delCart(data) {
  return http.post("cart/delete",data)
}



// WEBPACK FOOTER //
// ./src/api/cart.js